import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate(data.role === "admin" ? "/admin" : "/portal", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex items-end gap-1 h-8">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className="eq-bar w-1.5 h-8 bg-gold rounded-full" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
    </div>
  );
}
